import { Typography } from '@mui/material'
import React from 'react'
import TableCaption from '../../components/table/TableCaption'
import { RouteConstants } from '../../navigation/navigation-types'

interface NoDataProps {
    link: RouteConstants
}

const NoData: React.FC<NoDataProps> = ({ link }: NoDataProps) => {
    return (
        <>
            <Typography variant='caption'>Žádný záznam</Typography>
            <table width={'100%'}>
                <TableCaption link={link} />
            </table>
        </>
    )
}

export default NoData
